<div #mainBox [class.top-box]="!isBottomBox" [class.bottom-box]="isBottomBox" class="pointer grouped-box" 
(clickOutside)="onClickOutside()"
[additionalElementRefs]="extraBoxes" [class.hide]="hideBox">
    <button  class="badge-count badge-count-green" (click)="openDetails($event)" >?</button>
    <div class="grouped-box-title">{{text}}</div>
    @for (targetSub of subTargets; track targetSub.ID) {
        <app-target-selector [target]="targetSub" [isBottomBox]="isBottomBox" 
        [promptCodes]="targetSub.PromptCodes??[]" [subTargetsDictionary]="subTargetsDictionary"
        [allPromptCodes]="allPromptCodes"
        [promptSchedules]="promptSchedules" 
        [enabled]="targetSub.Enabled" [isPreview]="isPreview"></app-target-selector>
    }
</div>


@if (detailsOpened) {
    <app-target-details [target]="target" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
    }